var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 1.46588V6.60959C9.5625 6.64688 9.57732 6.68265 9.60369 6.70902C9.63006 6.7354 9.66583 6.75021 9.70313 6.75021H14.8468C14.8607 6.75022 14.8743 6.74612 14.8859 6.73842C14.8974 6.73071 14.9065 6.71976 14.9118 6.70693C14.9171 6.6941 14.9186 6.67998 14.9159 6.66635C14.9132 6.65272 14.9066 6.64018 14.8968 6.63033L9.68238 1.41595C9.67253 1.40616 9.66 1.3995 9.64636 1.39683C9.63273 1.39415 9.61861 1.39557 9.60578 1.40091C9.59296 1.40625 9.582 1.41527 9.5743 1.42684C9.56659 1.4384 9.56249 1.45198 9.5625 1.46588Z",
    fill: "#253837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 7.875C8.64416 7.875 8.57262 7.84537 8.51988 7.79262C8.46713 7.73988 8.4375 7.66834 8.4375 7.59375V1.125H3.23438C3.12249 1.125 3.01518 1.16945 2.93606 1.24856C2.85695 1.32768 2.8125 1.43499 2.8125 1.54688V16.4531C2.8125 16.565 2.85695 16.6723 2.93606 16.7514C3.01518 16.8306 3.12249 16.875 3.23438 16.875H14.7656C14.8775 16.875 14.9848 16.8306 15.0639 16.7514C15.1431 16.6723 15.1875 16.565 15.1875 16.4531V7.875H8.71875ZM12.375 13.5H5.625V12.375H12.375V13.5ZM12.375 10.6875H5.625V9.5625H12.375V10.6875Z",
    fill: "#253837"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon02);
export default __webpack_public_path__ + "static/media/docIcon02.4ae872392032a37a8e3339e2a8ee19c8.svg";
export { ForwardRef as ReactComponent };